import { format } from '@sravni/utils/lib/money';
import { Currency } from '../../constants/currency.js';
import { TERMS } from '../../constants/terms.js';
import { getAmountRangeToString, getAmountString } from '../../helpers/humanization.js';
import { plur } from '../../helpers/plur.js';

const getCriticalIllnessTerms = item => {
    const conditions = [];
    // возраст, страховая сумма, цена
    // возраст
    const { ageFrom, ageTo } = item;
    const ageValue = getAmountRangeToString({
        amountRange: {
            from: ageFrom,
            to: ageTo,
        },
        isFloat: false,
        prefix: false,
        allowZero: true,
        defaultText: 'Любой',
    });
    conditions.push({
        value: `${ageValue} ${plur({ value: ageFrom || ageTo, unit: TERMS.years })}`,
        description: 'Возраст',
        key: 'age',
    });
    // страховая сумма
    const { sumDollar, sumEuro, sumRub } = item;
    let sumValue;
    if (sumDollar > 0) {
        sumValue = getAmountString(sumDollar, Currency.USD);
    }
    else if (sumEuro > 0) {
        sumValue = getAmountString(sumEuro, Currency.EUR);
    }
    else {
        sumValue = getAmountString(sumRub, Currency.RUB);
    }
    conditions.push({
        value: sumValue,
        description: 'Страховая сумма',
        wide: true,
        key: 'sum',
    });
    // цена
    const { priceFrom } = item;
    const priceValue = `${format(priceFrom, false)} ₽ в год`;
    conditions.push({ value: priceValue, description: 'Стоимость', wide: true, key: 'price' });
    return conditions;
};

export { getCriticalIllnessTerms };
//# sourceMappingURL=criticalIllness.js.map
